import { FieldProps } from 'formik';
import { RadioButton } from 'src/components';
import React from 'react';
import { NotificationMethod, PaymentType } from 'src/services/payment-request-service';
import {
  LinkName,
  PageName,
  PaymentRequestTealiumService,
  UIInteractionType,
} from 'src/containers/self-service/generate-payment-request/tagging/payment-request-tealium-service';

interface Props extends FieldProps {
  automationId: string;
  light: boolean;
  label: string;
  small: boolean;
  clearField?: string;
  paymentType: PaymentType;
  notificationAddress: string;
}

export function tagOnChange(notificationMethod: NotificationMethod, paymentType: PaymentType) {
  const link =
    paymentType === PaymentType.FixedAmount
      ? LinkName.GENERATE_PAYMENT_REQUEST_NOTIFICATION_METHOD_FIXED
      : LinkName.GENERATE_PAYMENT_REQUEST_NOTIFICATION_METHOD_VARIABLE;
  const page =
    paymentType === PaymentType.FixedAmount
      ? PageName.GENERATE_PAYMENT_REQUEST_DETAILS_FIXED
      : PageName.GENERATE_PAYMENT_REQUEST_DETAILS_VARIABLE;

  PaymentRequestTealiumService.onUIInteraction(
    link,
    UIInteractionType[notificationMethod],
    '',
    page,
  );
}

export function NotificationTypeRadioButton({
  label,
  automationId,
  clearField,
  field,
  light,
  small = false,
  ...props
}: Props) {
  return (
    <RadioButton
      field={field}
      label={label}
      automationId={automationId}
      light={light}
      small={small}
      {...props}
      onChange={(e) => {
        props.form.setFieldValue(field.name, e.target.value);
        clearField && props.form.setFieldValue(clearField, '');
        clearField && props.form.setFieldTouched(clearField, false);
        tagOnChange(e.target.value, props.paymentType);
      }}
    />
  );
}
